import CarouselContainer from "../components/CarouselContainer"
import ServicesCardContainer from "../components/ServicesCardContainer"
import WhyUsSection from "../components/WhyUsSection"
import Partners from "../components/Partners"


export default function Home(){

    

    return(
        <>
        <CarouselContainer/>
        <ServicesCardContainer/>
        <WhyUsSection/>
        <Partners/>
        </>
    )
}